import { ModalService } from '@app/base/service/modal.service';
import { ControlService } from './base/service/control.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { SmartadminLayoutModule } from '@app/shared/layout';
import { AppConfig } from '@app/config/app.config';
import { HttpModule } from '@angular/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginService } from '@app/features/login/service/login.service';
import { AddHeaderInterceptor } from '@app/base/interceptors/addheader.interceptor';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { registerLocaleData, APP_BASE_HREF } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { UnathorizedInterceptor } from './base/interceptors/unathorized.interceptor';

export function initializeApp(appConfig: AppConfig) {
	return () => appConfig.load();
}

registerLocaleData(localePt, 'pt');

@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		SharedModule,
		CoreModule,
		SmartadminLayoutModule,
		HttpModule,
		SnotifyModule,
	],
	exports: [
	],
	providers: [
		AppConfig,
		LoginService,
		{
			provide: APP_INITIALIZER,
			useFactory: initializeApp,
			deps: [AppConfig], multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AddHeaderInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: UnathorizedInterceptor,
			multi: true,
		},
		{
			provide: APP_BASE_HREF,
			useValue: window['base-href'],
		},
		{ provide: 'SnotifyToastConfig', useValue: ToastDefaults },
		SnotifyService,
		{ provide: LOCALE_ID, useValue: 'pt' },
		ControlService,
		ModalService,
	],
	bootstrap: [
		AppComponent,
	],
})
export class AppModule { }
